import { cn } from "@/lib/utils"

/**
 * Skeleton loading component
 * 
 * Uses bg-foreground/10 instead of bg-muted for better theme consistency.
 * This ensures the skeleton shimmer adapts to any theme during initial load,
 * preventing color mismatches when skeletons render before theme is fully applied.
 */
function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-foreground/10", className)}
      {...props}
    />
  )
}

export { Skeleton }
